import { useRouter } from "next/router";
import Icon from "@ui-kit/icons/Icon.web";
import Flex from "@ui-kit/layout/Flex/Flex.web";
import Menu from "@ui-kit/overlays/Menu/Menu.web";
import { useTranslation } from "@shared/utils/internationalization";
import { NavBarMenuProps } from "./NavBarMenu.props";

const NavBarMenu = ({ links }: NavBarMenuProps) => {
  const { t } = useTranslation("common");
  const router = useRouter();

  const handleSelect = (details: { value: string }) => {
    const link = links.find((l) => l.href === details.value);
    if (link?.external) {
      window.location.href = details.value;
    } else {
      router.push(details.value);
    }
  };

  return (
    <Menu onSelect={handleSelect}>
      <Menu.Button
        data-testid="navbar-menu"
        h="element.3xl"
        px="md"
        borderRadius="sm"
        transition="all 0.2s"
        _hover={{
          _light: { bg: "gray.300" },
          _dark: { bg: "whiteAlpha.200" },
        }}
      >
        <Flex
          alignItems="center"
          gap="2xs"
          color="fg"
          fontSize="md"
          fontWeight="400"
        >
          {t("Host An Event")}
          <Icon.ChevronDown boxSize="element.md" color="fg" />
        </Flex>
      </Menu.Button>
      <Menu.List>
        {links.map((link) => (
          <Menu.Item key={link.label} value={link.href}>
            {link.label}
          </Menu.Item>
        ))}
      </Menu.List>
    </Menu>
  );
};

export default NavBarMenu;
